// Aceita `number | undefined | null` (nao so `number`) para permitir campos opcionais de
// ResumoFinanceiro/QuebraFinanceira (financeiro-dashboard-plataforma Phase 4 — extensao aditiva
// que nao pode quebrar, em tempo de compilacao, fixtures de fases anteriores que nao selecionam
// os 2 campos novos). Alargamento estritamente compativel — todo call site existente que ja
// passa `number` continua funcionando identico.
export function formatCurrency(value: number | undefined | null): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value ?? 0);
}
